import { Axios, AxiosInstance } from 'axios';
import apiConfig from './ApiConfig';
import { setAxiosFactory } from './axios-client';

export const initQuery = () => {
    setAxiosFactory(() => apiConfig);
};
